import { PredefinedAudience } from '@nexxt/common/types';
import { BUILT_IN_TARGET_QVALUE } from '@nexxt/common/demographics/types';

export enum PREDEFINED_GROUP_TYPES {
    SEGMENT = 'SEGMENT',
    ADD_ON = 'ADD_ON'
}

export const PREDEFINED_GROUP_TITLE = {
    [PREDEFINED_GROUP_TYPES.SEGMENT]: {
        title: 'D&I Segment [N=50]',
        subTitle: 'Select 1'
    },
    [PREDEFINED_GROUP_TYPES.ADD_ON]: {
        title: 'Optional Add-Ons',
        subTitle: 'Select up to 1 of each category'
    }
};

export const PREDEFINED_GROUP_KEYS = {
    LGBTQ: 'LGBTQ+',
    BIPOC: 'BIPOC',
    DISABILITIES: 'DISABILITIES',
    MIX_LGBTQ_BIPOC: 'MIX_LGBTQ_BIPOC',
    MIX_LGBTQ_BIPOC_DISABILITIES: 'MIX_LGBTQ_BIPOC_DISABILITIES',
    YOUTH: 'Youth (18-29)',
    GEN_POP: 'General Population (18+)'
};

export const TARGET_GROUPS: {
    [PREDEFINED_GROUP_TYPES.SEGMENT]: { [key: string]: PredefinedAudience[] };
    [PREDEFINED_GROUP_TYPES.ADD_ON]: { [key: string]: PredefinedAudience[] };
} = {
    [PREDEFINED_GROUP_TYPES.SEGMENT]: {
        [PREDEFINED_GROUP_KEYS.LGBTQ]: [
            {
                label: 'LGBTQ+',
                subLabel: '(18+)',
                groupValue: 'in.nexxt/targetGroup/1',
                totalCount: 50,
                price: 800,
                terminates: [
                    {
                        builtInId: BUILT_IN_TARGET_QVALUE.AGE,
                        builtInOptionValues: ['2', '3', '4', '5', '6'],
                        attributeId: '13',
                        attributeOptions: ['18-99']
                    },
                    {
                        builtInId: BUILT_IN_TARGET_QVALUE.DIVERSITY_SINGLE,
                        builtInOptionValues: ['1', '2', '3', '4', '5'], // to terminate NOT APPLICABLE
                        attributeId: null,
                        attributeOptions: []
                    },
                    {
                        builtInId:
                            BUILT_IN_TARGET_QVALUE.DIVERSITY_INTERLOCK_GROUP_1,
                        builtInOptionValues: ['1'],
                        attributeId: null,
                        attributeOptions: []
                    }
                ],
                quotas: [
                    {
                        id: 1,
                        incidenceRate: 80,
                        count: 50,
                        label: 'LGBTQ+',
                        quotaRule: {
                            builtInId:
                                BUILT_IN_TARGET_QVALUE.DIVERSITY_INTERLOCK,
                            builtInOptionValues: ['1'],
                            attributeId: '12375035',
                            attributeOptions: ['2', '3', '4', '5', '6']
                        }
                    }
                ]
            },
            {
                label: 'LGBTQ+',
                subLabel: '(18-35)',
                groupValue: 'in.nexxt/targetGroup/1',
                totalCount: 50,
                price: 1000,
                terminates: [
                    {
                        builtInId: BUILT_IN_TARGET_QVALUE.AGE,
                        builtInOptionValues: ['2', '3'],
                        attributeId: '13',
                        attributeOptions: ['18-35']
                    },
                    {
                        builtInId: BUILT_IN_TARGET_QVALUE.DIVERSITY_SINGLE,
                        builtInOptionValues: ['1', '2', '3', '4', '5'], // to terminate NOT APPLICABLE
                        attributeId: null,
                        attributeOptions: []
                    },
                    {
                        builtInId:
                            BUILT_IN_TARGET_QVALUE.DIVERSITY_INTERLOCK_GROUP_1,
                        builtInOptionValues: ['1'],
                        attributeId: null,
                        attributeOptions: []
                    }
                ],
                quotas: [
                    {
                        id: 1,
                        incidenceRate: 80,
                        count: 50,
                        label: 'LGBTQ+',
                        quotaRule: {
                            builtInId:
                                BUILT_IN_TARGET_QVALUE.DIVERSITY_INTERLOCK,
                            builtInOptionValues: ['1'],
                            attributeId: '12375035',
                            attributeOptions: ['2', '3', '4', '5', '6']
                        }
                    }
                ]
            }
        ],
        [PREDEFINED_GROUP_KEYS.BIPOC]: [
            {
                label: 'BIPOC',
                subLabel: '(18+)',
                groupValue: 'in.nexxt/targetGroup/2',
                totalCount: 50,
                price: 800,
                terminates: [
                    {
                        builtInId: BUILT_IN_TARGET_QVALUE.AGE,
                        builtInOptionValues: ['2', '3', '4', '5', '6'],
                        attributeId: '13',
                        attributeOptions: ['18-99']
                    },
                    {
                        builtInId: BUILT_IN_TARGET_QVALUE.DIVERSITY_SINGLE,
                        builtInOptionValues: ['1', '2', '3', '4', '5'],
                        attributeId: null,
                        attributeOptions: []
                    },
                    {
                        builtInId:
                            BUILT_IN_TARGET_QVALUE.DIVERSITY_INTERLOCK_GROUP_2,
                        builtInOptionValues: ['1'],
                        attributeId: null,
                        attributeOptions: []
                    }
                ],
                quotas: [
                    {
                        id: 1,
                        incidenceRate: 80,
                        count: 50,
                        label: 'BIPOC',
                        quotaRule: {
                            builtInId:
                                BUILT_IN_TARGET_QVALUE.DIVERSITY_INTERLOCK,
                            builtInOptionValues: ['2'],
                            attributeId: '12376912',
                            attributeOptions: [
                                '9',
                                '10',
                                '13',
                                '17',
                                '18',
                                '49',
                                '50'
                            ]
                        }
                    }
                ]
            },
            {
                label: 'BIPOC',
                subLabel: '(18-35)',
                groupValue: 'in.nexxt/targetGroup/2',
                totalCount: 50,
                price: 1000,
                terminates: [
                    {
                        builtInId: BUILT_IN_TARGET_QVALUE.AGE,
                        builtInOptionValues: ['2', '3'],
                        attributeId: '13',
                        attributeOptions: ['18-35']
                    },
                    {
                        builtInId: BUILT_IN_TARGET_QVALUE.DIVERSITY_SINGLE,
                        builtInOptionValues: ['1', '2', '3', '4', '5'],
                        attributeId: null,
                        attributeOptions: []
                    },
                    {
                        builtInId:
                            BUILT_IN_TARGET_QVALUE.DIVERSITY_INTERLOCK_GROUP_2,
                        builtInOptionValues: ['1'],
                        attributeId: null,
                        attributeOptions: []
                    }
                ],
                quotas: [
                    {
                        id: 1,
                        incidenceRate: 80,
                        count: 50,
                        label: 'BIPOC',
                        quotaRule: {
                            builtInId:
                                BUILT_IN_TARGET_QVALUE.DIVERSITY_INTERLOCK,
                            builtInOptionValues: ['2'],
                            attributeId: '12376912',
                            attributeOptions: [
                                '9',
                                '10',
                                '13',
                                '17',
                                '18',
                                '49',
                                '50'
                            ]
                        }
                    }
                ]
            }
        ],
        [PREDEFINED_GROUP_KEYS.DISABILITIES]: [
            {
                label: 'Persons with disabilities',
                subLabel: '(18+)',
                groupValue: 'in.nexxt/targetGroup/3',
                totalCount: 50,
                price: 800,
                terminates: [
                    {
                        builtInId: BUILT_IN_TARGET_QVALUE.AGE,
                        builtInOptionValues: ['2', '3', '4', '5', '6'],
                        attributeId: '13',
                        attributeOptions: ['18-99']
                    },
                    {
                        builtInId: BUILT_IN_TARGET_QVALUE.DIVERSITY_SINGLE,
                        builtInOptionValues: ['1', '2', '3', '4', '5'],
                        attributeId: null,
                        attributeOptions: []
                    },
                    {
                        builtInId:
                            BUILT_IN_TARGET_QVALUE.DIVERSITY_INTERLOCK_GROUP_3,
                        builtInOptionValues: ['1'],
                        attributeId: null,
                        attributeOptions: []
                    }
                ],
                quotas: [
                    {
                        id: 1,
                        incidenceRate: 20,
                        count: 50,
                        label: 'Disabilities',
                        quotaRule: {
                            builtInId:
                                BUILT_IN_TARGET_QVALUE.DIVERSITY_INTERLOCK,
                            builtInOptionValues: ['3'],
                            attributeId: '11',
                            attributeOptions: ['1', '2']
                        }
                    }
                ]
            },
            {
                label: 'Persons with disabilities',
                subLabel: '(18-35)',
                groupValue: 'in.nexxt/targetGroup/3',
                totalCount: 50,
                price: 1000,
                terminates: [
                    {
                        builtInId: BUILT_IN_TARGET_QVALUE.AGE,
                        builtInOptionValues: ['2', '3'],
                        attributeId: '13',
                        attributeOptions: ['18-35']
                    },
                    {
                        builtInId: BUILT_IN_TARGET_QVALUE.DIVERSITY_SINGLE,
                        builtInOptionValues: ['1', '2', '3', '4', '5'],
                        attributeId: null,
                        attributeOptions: []
                    },
                    {
                        builtInId:
                            BUILT_IN_TARGET_QVALUE.DIVERSITY_INTERLOCK_GROUP_3,
                        builtInOptionValues: ['1'],
                        attributeId: null,
                        attributeOptions: []
                    }
                ],
                quotas: [
                    {
                        id: 1,
                        incidenceRate: 20,
                        count: 50,
                        label: 'Disabilities',
                        quotaRule: {
                            builtInId:
                                BUILT_IN_TARGET_QVALUE.DIVERSITY_INTERLOCK,
                            builtInOptionValues: ['3'],
                            attributeId: '11',
                            attributeOptions: ['1', '2']
                        }
                    }
                ]
            }
        ],
        [PREDEFINED_GROUP_KEYS.MIX_LGBTQ_BIPOC]: [
            {
                label: 'Mix of LGBTQ+ and BIPOC',
                subLabel: '(18+)',
                groupValue: 'in.nexxt/targetGroup/4',
                totalCount: 50,
                price: 800,
                terminates: [
                    {
                        builtInId: BUILT_IN_TARGET_QVALUE.AGE,
                        builtInOptionValues: ['2', '3', '4', '5', '6'],
                        attributeId: '13',
                        attributeOptions: ['18-99']
                    },
                    {
                        builtInId: BUILT_IN_TARGET_QVALUE.DIVERSITY_SINGLE,
                        builtInOptionValues: ['1', '2', '3', '4', '5'],
                        attributeId: null,
                        attributeOptions: []
                    },
                    {
                        builtInId:
                            BUILT_IN_TARGET_QVALUE.DIVERSITY_INTERLOCK_GROUP_4,
                        builtInOptionValues: ['1'],
                        attributeId: null,
                        attributeOptions: []
                    }
                ],
                quotas: [
                    {
                        id: 1,
                        count: 30,
                        incidenceRate: 80,
                        label: 'LBGTQ',
                        quotaRule: {
                            builtInId:
                                BUILT_IN_TARGET_QVALUE.DIVERSITY_INTERLOCK,
                            builtInOptionValues: ['1'],
                            attributeId: '12375035',
                            attributeOptions: ['2', '3', '4', '5', '6']
                        }
                    },
                    {
                        id: 2,
                        count: 30,
                        label: 'BIPOC',
                        incidenceRate: 80,
                        quotaRule: {
                            builtInId:
                                BUILT_IN_TARGET_QVALUE.DIVERSITY_INTERLOCK,
                            builtInOptionValues: ['2'],
                            attributeId: '12376912',
                            attributeOptions: [
                                '9',
                                '10',
                                '13',
                                '17',
                                '18',
                                '49',
                                '50'
                            ]
                        }
                    }
                ]
            },
            {
                label: 'Mix of LGBTQ+ and BIPOC',
                subLabel: '(18-35)',
                groupValue: 'in.nexxt/targetGroup/4',
                totalCount: 50,
                price: 1000,
                terminates: [
                    {
                        builtInId: BUILT_IN_TARGET_QVALUE.AGE,
                        builtInOptionValues: ['2', '3'],
                        attributeId: '13',
                        attributeOptions: ['18-35']
                    },
                    {
                        builtInId: BUILT_IN_TARGET_QVALUE.DIVERSITY_SINGLE,
                        builtInOptionValues: ['1', '2', '3', '4', '5'],
                        attributeId: null,
                        attributeOptions: []
                    },
                    {
                        builtInId:
                            BUILT_IN_TARGET_QVALUE.DIVERSITY_INTERLOCK_GROUP_4,
                        builtInOptionValues: ['1'],
                        attributeId: null,
                        attributeOptions: []
                    }
                ],
                quotas: [
                    {
                        id: 1,
                        count: 30,
                        incidenceRate: 80,
                        label: 'LBGTQ',
                        quotaRule: {
                            builtInId:
                                BUILT_IN_TARGET_QVALUE.DIVERSITY_INTERLOCK,
                            builtInOptionValues: ['1'],
                            attributeId: '12375035',
                            attributeOptions: ['2', '3', '4', '5', '6']
                        }
                    },
                    {
                        id: 2,
                        count: 30,
                        label: 'BIPOC',
                        incidenceRate: 80,
                        quotaRule: {
                            builtInId:
                                BUILT_IN_TARGET_QVALUE.DIVERSITY_INTERLOCK,
                            builtInOptionValues: ['2'],
                            attributeId: '12376912',
                            attributeOptions: [
                                '9',
                                '10',
                                '13',
                                '17',
                                '18',
                                '49',
                                '50'
                            ]
                        }
                    }
                ]
            }
        ],
        [PREDEFINED_GROUP_KEYS.MIX_LGBTQ_BIPOC_DISABILITIES]: [
            {
                label: 'Mix of LGBTQ+, BIPOC, and Person with disabilities',
                subLabel: '(18+)',
                groupValue: 'in.nexxt/targetGroup/5',
                totalCount: 50,
                price: 800,
                terminates: [
                    {
                        builtInId: BUILT_IN_TARGET_QVALUE.AGE,
                        builtInOptionValues: ['2', '3', '4', '5', '6'],
                        attributeId: '13',
                        attributeOptions: ['18-99']
                    },
                    {
                        builtInId: BUILT_IN_TARGET_QVALUE.DIVERSITY_SINGLE,
                        builtInOptionValues: ['1', '2', '3', '4', '5'],
                        attributeId: null,
                        attributeOptions: []
                    },
                    {
                        builtInId:
                            BUILT_IN_TARGET_QVALUE.DIVERSITY_INTERLOCK_GROUP_5,
                        builtInOptionValues: ['1'],
                        attributeId: null,
                        attributeOptions: []
                    }
                ],
                quotas: [
                    {
                        id: 1,
                        count: 25,
                        incidenceRate: 80,
                        label: 'LGBTQ+',
                        quotaRule: {
                            builtInId:
                                BUILT_IN_TARGET_QVALUE.DIVERSITY_INTERLOCK,
                            builtInOptionValues: ['1'],
                            attributeId: '12375035',
                            attributeOptions: ['2', '3', '4', '5', '6']
                        }
                    },
                    {
                        id: 2,
                        count: 25,
                        incidenceRate: 80,
                        label: 'BIPOC',
                        quotaRule: {
                            builtInId:
                                BUILT_IN_TARGET_QVALUE.DIVERSITY_INTERLOCK,
                            builtInOptionValues: ['2'],
                            attributeId: '12376912',
                            attributeOptions: [
                                '9',
                                '10',
                                '13',
                                '17',
                                '18',
                                '49',
                                '50'
                            ]
                        }
                    },
                    {
                        id: 3,
                        count: 10,
                        incidenceRate: 20,
                        label: 'Disabilities',
                        quotaRule: {
                            builtInId:
                                BUILT_IN_TARGET_QVALUE.DIVERSITY_INTERLOCK,
                            builtInOptionValues: ['3'],
                            attributeId: '11',
                            attributeOptions: ['1', '2']
                        }
                    }
                ]
            },
            {
                label: 'Mix of LGBTQ+, BIPOC, and Person with disabilities',
                subLabel: '(18-35)',
                groupValue: 'in.nexxt/targetGroup/5',
                totalCount: 50,
                price: 1000,
                terminates: [
                    {
                        builtInId: BUILT_IN_TARGET_QVALUE.AGE,
                        builtInOptionValues: ['2', '3'],
                        attributeId: '13',
                        attributeOptions: ['18-35']
                    },
                    {
                        builtInId: BUILT_IN_TARGET_QVALUE.DIVERSITY_SINGLE,
                        builtInOptionValues: ['1', '2', '3', '4', '5'],
                        attributeId: null,
                        attributeOptions: []
                    },
                    {
                        builtInId:
                            BUILT_IN_TARGET_QVALUE.DIVERSITY_INTERLOCK_GROUP_5,
                        builtInOptionValues: ['1'],
                        attributeId: null,
                        attributeOptions: []
                    }
                ],
                quotas: [
                    {
                        id: 1,
                        count: 25,
                        incidenceRate: 80,
                        label: 'LGBTQ+',
                        quotaRule: {
                            builtInId:
                                BUILT_IN_TARGET_QVALUE.DIVERSITY_INTERLOCK,
                            builtInOptionValues: ['1'],
                            attributeId: '12375035',
                            attributeOptions: ['2', '3', '4', '5', '6']
                        }
                    },
                    {
                        id: 2,
                        count: 25,
                        incidenceRate: 80,
                        label: 'BIPOC',
                        quotaRule: {
                            builtInId:
                                BUILT_IN_TARGET_QVALUE.DIVERSITY_INTERLOCK,
                            builtInOptionValues: ['2'],
                            attributeId: '12376912',
                            attributeOptions: [
                                '9',
                                '10',
                                '13',
                                '17',
                                '18',
                                '49',
                                '50'
                            ]
                        }
                    },
                    {
                        id: 3,
                        count: 10,
                        incidenceRate: 20,
                        label: 'Disabilities',
                        quotaRule: {
                            builtInId:
                                BUILT_IN_TARGET_QVALUE.DIVERSITY_INTERLOCK,
                            builtInOptionValues: ['3'],
                            attributeId: '11',
                            attributeOptions: ['1', '2']
                        }
                    }
                ]
            }
        ]
    },
    [PREDEFINED_GROUP_TYPES.ADD_ON]: {
        [PREDEFINED_GROUP_KEYS.YOUTH]: [
            {
                label: 'Youth (18-29) N=25',
                groupValue: 'in.nexxt/targetGroup/6',
                totalCount: 25,
                price: 150,
                terminates: [],
                quotas: [
                    {
                        id: 1,
                        incidenceRate: 90,
                        count: 25,
                        label: 'Youth',
                        quotaRule: {
                            builtInId: BUILT_IN_TARGET_QVALUE.AGE,
                            builtInOptionValues: ['2'],
                            attributeId: '13',
                            attributeOptions: ['18-29']
                        }
                    },
                    {
                        id: 2,
                        incidenceRate: null,
                        count: 3,
                        label: 'LGBTQ+',
                        quotaRule: {
                            builtInId:
                                BUILT_IN_TARGET_QVALUE.DIVERSITY_INTERLOCK,
                            builtInOptionValues: ['1'],
                            attributeId: null,
                            attributeOptions: []
                        }
                    }
                ]
            },
            {
                label: 'Youth (18-29) N=50',
                groupValue: 'in.nexxt/targetGroup/6',
                totalCount: 50,
                price: 300,
                terminates: [],
                quotas: [
                    {
                        id: 1,
                        incidenceRate: 90,
                        count: 50,
                        label: 'Youth',
                        quotaRule: {
                            builtInId: BUILT_IN_TARGET_QVALUE.AGE,
                            builtInOptionValues: ['2'],
                            attributeId: '13',
                            attributeOptions: ['18-29']
                        }
                    },
                    {
                        id: 2,
                        incidenceRate: null,
                        count: 6,
                        label: 'LGBTQ+',
                        quotaRule: {
                            builtInId:
                                BUILT_IN_TARGET_QVALUE.DIVERSITY_INTERLOCK,
                            builtInOptionValues: ['1'],
                            attributeId: null,
                            attributeOptions: []
                        }
                    }
                ]
            }
        ],
        [PREDEFINED_GROUP_KEYS.GEN_POP]: [
            {
                label: 'General Population N=25',
                groupValue: 'in.nexxt/targetGroup/7',
                totalCount: 25,
                price: 150,
                terminates: [
                    {
                        builtInId: BUILT_IN_TARGET_QVALUE.AGE,
                        builtInOptionValues: ['2', '3', '4', '5', '6'],
                        attributeId: '13',
                        attributeOptions: ['18-99']
                    }
                ],
                quotas: [
                    {
                        id: 1,
                        incidenceRate: 90,
                        count: 25,
                        label: 'General Population',
                        quotaRule: {
                            builtInId: null,
                            builtInOptionValues: [],
                            attributeId: '11',
                            attributeOptions: ['1', '2']
                        }
                    },
                    {
                        id: 2,
                        incidenceRate: null,
                        count: 3,
                        label: 'LGBTQ+',
                        quotaRule: {
                            builtInId:
                                BUILT_IN_TARGET_QVALUE.DIVERSITY_INTERLOCK,
                            builtInOptionValues: ['1'],
                            attributeId: null,
                            attributeOptions: []
                        }
                    }
                ]
            },
            {
                label: 'General Population N=50',
                groupValue: 'in.nexxt/targetGroup/7',
                totalCount: 50,
                price: 300,
                terminates: [
                    {
                        builtInId: BUILT_IN_TARGET_QVALUE.AGE,
                        builtInOptionValues: ['2', '3', '4', '5', '6'],
                        attributeId: '13',
                        attributeOptions: ['18-99']
                    }
                ],
                quotas: [
                    {
                        id: 1,
                        incidenceRate: 90,
                        count: 50,
                        label: 'General Population',
                        quotaRule: {
                            builtInId: null,
                            builtInOptionValues: [],
                            attributeId: '11',
                            attributeOptions: ['1', '2']
                        }
                    },
                    {
                        id: 2,
                        incidenceRate: null,
                        count: 6,
                        label: 'LGBTQ+',
                        quotaRule: {
                            builtInId:
                                BUILT_IN_TARGET_QVALUE.DIVERSITY_INTERLOCK,
                            builtInOptionValues: ['1'],
                            attributeId: null,
                            attributeOptions: []
                        }
                    }
                ]
            }
        ]
    }
};
export const MAPPING_TARGETTING_OPTIONS = [
    {
        label: 'Qualify',
        value: 'Qualify'
    },
    {
        label: 'Disqualify',
        value: 'Disqualify'
    }
];
// Questions corrsponding to the Dynata attributes

// LGBTQ - targeting variables: 1) "Sexual Orientation" to target excluding Heterosexual, 2) "Age" to target 18+ or 18-35
//   sexual orientation(12375035) - 2,3,4,5,6, age(13)

// BIPOC - targeting variables: 1) "Race/Ethnicity" to target excluding Caucasian/White, 2) "Age" to target 18+ or 18-35
//   Rate/Ethnicity(12376912) - 9,10,13,17,18,49,50, age(13)

// Disabilities - targeting variable: "Age" to target 18+ or 18-35
//   age(13)

// Youth - targeting variable: "Age" to target 18-29
//   age(13)

// Genpop - targeting variable: "Age" to target 18+
//   age(13)

// Sample size
//  1. LGBTQ+ - N=50
//   TOTAL NUMBER = 50
//   quotaPlan: {
//      filters: [{attributeId: '13', options: ['18-99'], operator: 'include'}],
//      quotaGroups: [{name: 'LGBTQ', quotaCells: [{count: 50, quotaNodes: [{attributeId: '12375035', options: ['2','3','4','5','6']}] } ]}]}
//   or
//   quotaPlan: {
//      filters: [{attributeId: '13', options: ['18-35'], operator: 'include'}],
//      quotaGroups: [{name: 'LGBTQ', quotaCells: [{count: 50, quotaNodes: [{attributeId: '12375035', options: ['2','3','4','5','6']}] } ]}]}

//  2. BIPOC - N=50
//   TOTAL NUMBER = 50
//   quotaPlan: {
//      filters: [{attributeId: '13', options: ['18-99'], operator: 'include'}],
//      quotaGroups: [{name: 'BIPOC', quotaCells: [{count: 50, quotaNodes: [{attributeId: '12376912', options: ['9', '10', '13', '17', '18', '49', '50']}] } ]}]}
//   or
//   quotaPlan: {
//      filters: [{attributeId: '13', options: ['18-35'], operator: 'include'}],
//      quotaGroups: [{name: 'BIPOC', quotaCells: [{count: 50, quotaNodes: [{attributeId: '12376912', options: ['9', '10', '13', '17', '18', '49', '50']}] } ]}]}

//  3. Persons with disabilities - N= 50
//   TOTAL NUMBER = 50
//   quotaPlan: {
//      filters: [{attributeId: '13', options: ['18-99'], operator: 'include'}],
//      quotaGroups: [{name: 'Disabilities', quotaCells: [{count: 50, quotaNodes: [{attributeId: '11', options: ['1', '2']}] } ]}]}
//   or
//   quotaPlan: {
//      filters: [{attributeId: '13', options: ['18-35'], operator: 'include'}],
//      quotaGroups: [{name: 'Disabilities', quotaCells: [{count: 50, quotaNodes: [{attributeId: '11', options: ['1', '2']}] } ]}]}

//  4. LGBTQ+ + BIPOC - N=50, each <30
//   TOTAL NUMBER = 50
//   quotaPlan: {
//      filters: [{attributeId: '13', options: ['18-99'], operator: 'include'}],
//      quotaGroups: [{name: 'BIPOC', quotaCells: [{count: 30, quotaNodes: [{attributeId: '12376912', options: ['9', '10', '13', '17', '18', '49', '50']} ]} ]},
//                    {name: 'LGBTQ', quotaCells: [{count: 30, quotaNodes: [{attributeId: '12375035', options: ['2','3','4','5','6']} ]} ]} ]}
//   or
//   quotaPlan: {
//      filters: [{attributeId: '13', options: ['18-35'], operator: 'include'}],
//      quotaGroups: [{name: 'BIPOC', quotaCells: [{count: 30, quotaNodes: [{attributeId: '12376912', options: ['9', '10', '13', '17', '18', '49', '50']} ]} ]},
//                    {name: 'LGBTQ', quotaCells: [{count: 30, quotaNodes: [{attributeId: '12375035', options: ['2','3','4','5','6']} ]} ]} ]}

//  5. LGBTQ+ + BIPOC + Persons with disabilities - N=50, each <20
//   TOTAL NUMBER = 50
//   quotaPlan: {
//      filters: [{attributeId: '13', options: ['18-99'], operator: 'include'}],
//      quotaGroups: [{name: 'BIPOC', quotaCells: [{count: 25, quotaNodes: [{attributeId: '12376912', options: ['9', '10', '13', '17', '18', '49', '50']} ]} ]},
//                    {name: 'LGBTQ', quotaCells: [{count: 25, quotaNodes: [{attributeId: '12375035', options: ['2','3','4','5','6']} ]} ]},
//                    {name: 'Person with disabilities', quotaCells: [{count: 10, quotaNodes: [{attributeId: '11', options: ['1', '2']}]} ]} ]}
//   or
//   quotaPlan: {
//      filters: [{attributeId: '13', options: ['18-35'], operator: 'include'}],
//      quotaGroups: [{name: 'BIPOC', quotaCells: [{count: 25, quotaNodes: [{attributeId: '12376912', options: ['9', '10', '13', '17', '18', '49', '50']} ]} ]},
//                    {name: 'LGBTQ', quotaCells: [{count: 25, quotaNodes: [{attributeId: '12375035', options: ['2','3','4','5','6']} ]} ]},
//                    {name: 'Person with disabilities', quotaCells: [{count: 10, quotaNodes: [{attributeId: '11', options: ['1', '2']}]} ]} ]}

//  6. Youth - N=25
//   TOTAL NUMBER = 25
//   quotaPlan: {
//      filters: [],
//      quotaGroups: [{name: 'Youth', quotaCells: [{count: 25, quotaNodes: [{attributeId: '13', options: ['18-29'] }] }]}
//  6.1. Youth - N=50
//   TOTAL NUMBER = 50
//   quotaPlan: {
//      filters: [],
//      quotaGroups: [{name: 'Youth', quotaCells: [{count: 50, quotaNodes: [{attributeId: '13', options: ['18-29']} ]}]}

//  7. General Poplulation N=25
//   TOTAL NUMBER = 25
//   quotaPlan: {
//      filters: [{attributeId: '13', options: ['18-99'], operator: 'include'}],
//      quotaGroups: [{name: 'General Population', quotaCells: [{count: 25, quotaNodes: [{attributeId: '11', options: ['1', '2']}]}] }]}
//  7.1. General Poplulation N=50
//   TOTAL NUMBER = 50
//   quotaPlan: {
//      filters: [{attributeId: '13', options: ['18-99'], operator: 'include'}],
//      quotaGroups: [{name: 'General Population', quotaCells: [{count: 50, quotaNodes: [{attributeId: '11', options: ['1', '2']}]}] }]}
